import type { CardHeaderProps} from '@chakra-ui/react'
import { CardHeader, Flex } from '@chakra-ui/react'

import { SectionHeading } from '@/components/Section/SectionHeading'

export interface SectionHeaderProps extends CardHeaderProps {
  asHeading?: boolean
}

export const SectionHeader = ({
  children,
  asHeading = true,
  ...rest
}: SectionHeaderProps) => {
  return (
    <CardHeader sx={{ py: 5 }} {...rest}>
      <Flex
        sx={{ gap: { base: 2, md: 8 }, alignItems: 'center', width: '100%' }}
      >
        {asHeading && <SectionHeading>{children}</SectionHeading>}

        {!asHeading && children}
      </Flex>
    </CardHeader>
  )
}
